import { State } from "./State";
import { TraversingState } from "./states/TraversingState";
export class StateContext {
    constructor() {
        this._state = new TraversingState({
            alpha: 1,
            currentIndex: -1,
            reference: { alt: 0, lat: 0, lon: 0 },
            trajectory: [],
        });
    }
    get state() {
        return State.Traversing;
    }
    get reference() {
        return this._state.reference;
    }
    get currentNode() {
        return this._state.currentNode;
    }
    get previousNode() {
        return this._state.previousNode;
    }
    get trajectory() {
        return this._state.trajectory;
    }
    get currentIndex() {
        return this._state.currentIndex;
    }
    get lastNode() {
        return this._state.trajectory[this._state.trajectory.length - 1];
    }
    get nodesAhead() {
        return this._state.trajectory.length - 1 - this._state.currentIndex;
    }
    update(fps) {
        this._state.update(fps);
    }
    append(nodes) {
        this._state.append(nodes);
    }
    prepend(nodes) {
        this._state.prepend(nodes);
    }
    remove(n) {
        this._state.remove(n);
    }
    clear() {
        this._state.clear();
    }
    clearPrior() {
        this._state.clearPrior();
    }
    cut() {
        this._state.cut();
    }
    set(nodes) {
        this._state.set(nodes);
    }
    setSpeed(speed) {
        this._state.setSpeed(speed);
    }
}
//# sourceMappingURL=StateContext.js.map